import { createSlice } from '@reduxjs/toolkit';

const shouldLogin = String(process.env.REACT_APP_DISABLE_LOGIN).toUpperCase() !== 'TRUE';

const slice = createSlice({
  name: 'app',
  initialState: {
    forceOAuthLogin: shouldLogin, // enable for an initial Login screen
    error: null,
    bottomSheetOpen: false,
    sidebarOpen: true,
    selected: {
      layer: null,
      id: null,
    },
  },
  reducers: {
    setError: (state, action) => {
      state.error = action.payload;
    },
    setBottomSheetOpen: (state, action) => {
      state.bottomSheetOpen = action.payload;
    },
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    setSidebarOpen: (state, action) => {
      state.sidebarOpen = action.payload;
    }
  },
});

export default slice.reducer;

export const setError = (payload) => ({ type: 'app/setError', payload });
export const setBottomSheetOpen = (payload) => ({
  type: 'app/setBottomSheetOpen',
  payload,
});

export const setSelected = (payload) => ({
  type: 'app/setSelected',
  payload,
});

export const setSidebarOpen = (payload) => ({
  type: 'app/setSidebarOpen',
  payload,
})
